import React, { useEffect, useState } from 'react';
import {
    Action,
    IChatData,
    IChatState,
} from '../../../../interfaces/chat.interface';
import './ChatInput.scss';

// @ts-ignore
import arrowIcon from '../../../../assets/icons/CDA/rounded_arrow.svg';

interface IProps {
    chatState: IChatState;
    setChatState: React.Dispatch<Action>;
    handleSendMessage: () => void;
}

const ChatInput = ({ chatState, setChatState, handleSendMessage }: IProps) => {
    const [text, setText] = useState('');

    const handleSubmit = async () => {
        if (
            text !== '' &&
            chatState.sessionId &&
            chatState.chatData[chatState.chatData.length - 1]?.from ===
                'Comfama'
        ) {
            const data = {
                id: String(Date.now()),
                from: 'Usuario',
                message: text,
                vote: null,
            } as IChatData;
            setChatState({
                type: 'ADD_MESSAGE',
                message: data,
            });
        }
    };

    const handleEnter = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') handleSubmit();
    };

    useEffect(() => {
        if (
            chatState.chatData[chatState.chatData.length - 1]?.from ===
            'Usuario'
        ) {
            handleSendMessage();
            setText('');
        }
    }, [chatState.chatData]);

    return (
        <div className="a-ChatInput">
            <input
                type="text"
                className="a-ChatInput__input"
                placeholder="Escribe un mensaje"
                value={text}
                onChange={(e) => setText(e.target.value)}
                onKeyDown={handleEnter}
            />
            <button
                className="a-ChatInput__send"
                onClick={handleSubmit}
                aria-label="Enviar mensaje"
            >
                <img src={arrowIcon} alt="arrow icon" />
            </button>
        </div>
    );
};

export default ChatInput;
